let lastHtml = localStorage.getItem('lastHtml');

/**
 * 刷新间隔
 */
const DURATION = 5 * 60000;

async function extractNewScripts() {
    let html = await fetch(`./?_timestamp=${Date.now()}`).then((resp) => resp.text());
    html = html.replaceAll(' ', '');
    html = html.replaceAll('\n', '');

    return html;
}

async function needUpdate() {
    const newHtml = await extractNewScripts();
    localStorage.setItem('lastHtml', newHtml);
    let ret = lastHtml !== newHtml;
    if (!lastHtml) {
        ret = false;
    }
    lastHtml = newHtml;
    return ret;
}

function autoRefresh() {
    setTimeout(async () => {
        const willUpdate = await needUpdate();
        if (willUpdate) {
            const result = confirm('页面有更新，点击刷新页面');
            if (result) {
                setTimeout(() => {
                    // @ts-ignore
                    location.reload(true);
                }, 300);
            } else {
                localStorage.removeItem('lastHtml');
            }
        }
        autoRefresh();
    }, DURATION);
}

if (import.meta.env.MODE !== 'development') {
    // autoRefresh();
}
